import { IEmployeeConfig } from "web/types/Employee";

import fallbackCalculatorCopy, {
  companySpecificOverrides,
  RentableGroupCalculatorCopy,
} from "../const/rentableGroupCalculatorCopy";

const getRentableGroupCalculatorCopy = (
  employeeConfig?: IEmployeeConfig,
  companyId?: string
): RentableGroupCalculatorCopy => {
  return {
    instructionHeader:
      employeeConfig?.rentableGroupCalculatorContentAboveCalculator ||
      fallbackCalculatorCopy.instructionHeader,
    fillCalculatorCheckbox:
      employeeConfig?.rentableGroupCalculatorFillCheckboxContent ||
      fallbackCalculatorCopy.fillCalculatorCheckbox,
    financingCheckbox:
      employeeConfig?.rentableGroupCalculatorFinancingCheckboxContent ||
      fallbackCalculatorCopy.financingCheckbox,
    calculatorHeader:
      employeeConfig?.rentableGroupCalculatorName ||
      fallbackCalculatorCopy.calculatorHeader,
    peopleCount:
      employeeConfig?.rentableGroupCalculatorHouseHoldCountTitle ||
      fallbackCalculatorCopy.peopleCount,
    averageIncome:
      employeeConfig?.rentableGroupCalculatorAverageIncomeTitle ||
      fallbackCalculatorCopy.averageIncome,
    incomeGroup:
      employeeConfig?.rentableGroupCalculatorRentableGroupTitle ||
      fallbackCalculatorCopy.incomeGroup,
    incomeGroupDeclared: fallbackCalculatorCopy.incomeGroupDeclared,
    noIncomeGroupAvailable:
      employeeConfig?.rentableGroupCalculatorNoRentableGroupThresholdContent ||
      fallbackCalculatorCopy.noIncomeGroupAvailable,
    removePerson: fallbackCalculatorCopy.removePerson,
    addPerson: fallbackCalculatorCopy.addPerson,
    personInHousehold:
      employeeConfig?.rentableGroupCalculatorHouseHoldTitle ||
      fallbackCalculatorCopy.personInHousehold,
    incomeInHousehold:
      employeeConfig?.rentableGroupCalculatorIncome ||
      fallbackCalculatorCopy.incomeInHousehold,
    totalIncomeTooHigh:
      (companyId && companySpecificOverrides[companyId]?.totalIncomeTooHigh) ||
      fallbackCalculatorCopy.totalIncomeTooHigh,
  };
};

export default getRentableGroupCalculatorCopy;
